module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard-nav margin-top-header"
  }, [_c('v-toolbar', {
    staticClass: "nav-z-index",
    attrs: {
      "fixed": "",
      "app": "",
      "flat": "",
      "height": "73"
    }
  }, [_c('content-top-header', {
    staticClass: "black-theme"
  }, [_c('template', {
    slot: "topHeader"
  }, [_c('ul', {
    staticClass: "width100"
  }, [_vm._l((_vm.tabs), function(tab) {
    return _c('li', {
      key: tab.id,
      staticClass: "nav-li",
      attrs: {
        "href": ("#" + (tab.id))
      }
    }, [_c('label', {
      staticClass: "nav-label",
      on: {
        "click": function($event) {
          _vm.setTab(tab.pathName)
        }
      }
    }, [(tab.icon) ? _c('img', {
      staticClass: "li-icon",
      attrs: {
        "src": tab.icon,
        "width": "18"
      }
    }) : _vm._e(), _vm._v("\n                      " + _vm._s(tab.title) + "\n                    ")])])
  }), _vm._v(" "), _c('v-spacer')], 2)])], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e5ca3b1","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboardnav/index.vue
// module id = 1639
// module chunks = 180